import { render, staticRenderFns } from "./LeftTopButton.vue?vue&type=template&id=5fa452ec&scoped=true&"
import script from "./LeftTopButton.vue?vue&type=script&lang=js&"
export * from "./LeftTopButton.vue?vue&type=script&lang=js&"
import style0 from "./LeftTopButton.vue?vue&type=style&index=0&id=5fa452ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa452ec",
  null
  
)

export default component.exports